export interface PainPoint {
  title: string
  lines: string[]
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 TROPPE INFORMAZIONI, NESSUN PERCORSO CHIARO...',
    lines: [
      'Un video spiega i sensori. Un altro parla di Zigbee. Un tutorial mostra Home Assistant. Poi trovi Matter. Thread. Hub. Gateway. Automazioni. Alexa. Google Home. Apple Home.',
      'Il problema non è trovare informazioni. Il problema è capire cosa imparare prima, cosa viene dopo e come collegare tutto in un unico progetto reale.',
      'Invece di seguire un percorso... Finisci per saltare continuamente da un argomento all’altro.',
    ],
  },
  {
    title: '⚠️ COMPATIBILITÀ, PROTOCOLLI E DISPOSITIVI CREANO CONFUSIONE',
    lines: [
      'Wi-Fi. Bluetooth. Zigbee. Z-Wave. Thread. Matter. Hub. Bridge. Gateway. Decine di dispositivi promettono di rendere la casa più intelligente.',
      'Ma acquistare un dispositivo è facile. Capire se è adatto al tuo progetto, se comunica con gli altri dispositivi e come integrarlo correttamente è un’altra cosa.',
      'Una scelta sbagliata può significare dispositivi incompatibili, applicazioni separate e automazioni che non funzionano come previsto.',
    ],
  },
  {
    title: '🏠 NON SAI COME PASSARE DALL’IDEA ALL’IMPIANTO',
    lines: [
      'Sapere cos’è un sensore non basta. Sapere cos’è Matter non basta. Guardare qualcuno configurare una Smart Home su YouTube non significa saperne progettare una.',
      'Quali ambienti devono essere analizzati? Dove vanno posizionati i dispositivi? Quale protocollo conviene utilizzare? Come organizzare stanze e zone? Quali automazioni hanno realmente senso? Come verificare che tutto funzioni?',
      'Senza un processo progressivo... È facile accumulare informazioni senza riuscire a trasformarle in un sistema concreto.',
    ],
  },
  {
    title: '😩 QUANDO QUALCOSA NON FUNZIONA, TUTTO DIVENTA PIÙ COMPLICATO',
    lines: [
      'Un sensore smette di rispondere. Un dispositivo non entra in pairing. L’automazione non parte. La rete non copre correttamente una stanza. Un prodotto richiede un hub che non avevi previsto. Due ecosistemi non comunicano come immaginavi.',
      'Conoscere singoli dispositivi non è il vero problema. Avere un metodo per progettare, configurare, testare e risolvere i problemi è ciò che fa la differenza.',
    ],
  },
]
